// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1870":"css/main","6170":"css/app"}[chunkId] + ".css";
};